import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this._onDocClick = this._onDocClick.bind(this);
    this._onKey = this._onKey.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this._onDocClick);
    document.removeEventListener("keydown", this._onKey);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.menuTarget.classList.remove("d-none");
    this.element.classList.add("is-open");
    const toggleBtn = this.element.querySelector(".ai-menu-toggle");
    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this._onDocClick);
    document.addEventListener("keydown", this._onKey);
    this.dispatch("opened");
  }

  close() {
    this.menuTarget.classList.add("d-none");
    this.element.classList.remove("is-open");
    const toggleBtn = this.element.querySelector(".ai-menu-toggle");
    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this._onDocClick);
    document.removeEventListener("keydown", this._onKey);
  }

  isOpen() {
    return !this.menuTarget.classList.contains("d-none");
  }

  _onDocClick(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  _onKey(event) {
    if (event.key === "Escape") this.close();
  }
}
